import { EventParams, EventType, myTrackerService } from "OK/metrics/MyTrackerService";
import { logDataInternally } from "OK/metrics/utils";
import { ActivityId } from "OK/metrics/TimespentTrackerTypes";

interface ITimespentTrackerService {
    trackTimespent: (eventData: EventParams) => void;
    startTimespent: (activityId: ActivityId, timespentAccountId: number) => void;
    stopTimespent: (activityId: ActivityId, timespentAccountId: number) => void;
    startPlayerTimespent: (timespentAccountId: number) => void;
}

export const TimespentTrackerService: ITimespentTrackerService = {
    trackTimespent(eventData: EventParams): void {
        myTrackerService.trackCustomEvent(eventData, false);
        logDataInternally(myTrackerService.logPrefix, myTrackerService.serviceName, eventData.type, String(eventData.activity));
    },

    startTimespent(activityId: ActivityId, timespentAccountId: number): void {
        const eventData: EventParams = {
            id: timespentAccountId,
            type: EventType.START_TIMESPENT,
            activity: activityId,
            canUseInBackground: false
        }

        this.trackTimespent(eventData);
    },

    stopTimespent(activityId: ActivityId, timespentAccountId: number): void {
        const eventData: EventParams = {
            id: timespentAccountId,
            type: EventType.STOP_TIMESPENT,
            activity: activityId
        }

        this.trackTimespent(eventData);
    },

    startPlayerTimespent(timespentAccountId: number): void {
        const eventData: EventParams = {
            id: timespentAccountId,
            type: EventType.START_PLAYER_TIMESPENT,
            activity: ActivityId.PLAYER
        }

        this.trackTimespent(eventData);
    }
}
